import body from "../../assets/shapes_svg/alert/body.svg";
import body2 from "../../assets/shapes_svg/alert/body2.svg";
import line from "../../assets/shapes_svg/alert/line.svg";
import { Modal, ModalBody } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./index.css";

const Alert = () => {
  const { t } = useTranslation();
  return (
    <div className="custom__alert">
      <img src={body} alt="" />
      <h4>{t("PAID_SECTION")}</h4>
    </div>
  );
};

export const AlertV3 = ({ open, decline, title, body, modalSize = "lg" }) => {
  const handleClose = () => {
    decline();
  };
  return (
    <Modal
      size={modalSize}
      dialogClassName="alert__v3"
      centered
      show={open}
      onHide={() => handleClose()}
    >
      <ModalBody className="d-flex justify-content-center align-items-center flex-column">
        <h5 className="text-center" style={{ marginBottom: "10px" }}>
          {title}
        </h5>
        <img className="mb-2 mt-1 w-50" src={line} alt="" />
        <div className="alert__v2">{body}</div>
      </ModalBody>
    </Modal>
  );
};

export const AlertV2 = ({ open, accept, decline, title }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    decline();
  };
  return (
    <Modal size="sm" centered show={open} onHide={() => handleClose()}>
      <ModalBody className="d-flex justify-content-center align-items-center">
        <div className="alert__v2">
          <h5 className="text-center">{title}</h5>
          <img className="mb-2 mt-1 w-50" src={line} alt="" />
          <div className="d-flex flex-column justify-content-center mt-2 mb-4 fle col-8 align-items-center">
            <h6 className="text-center">{t("CONFIRM_SAVE")}</h6>
            <div className="alert__buttons mt-4">
              <Button text={t("IM_SURE")} click={accept} />
              <Button text={t("CANCEL")} click={decline} />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
  return (
    <div className="custom__alert alert__v2">
      <img src={body2} alt="" />
      <div className="alert__body">
        <h3>{t("DELETE_SUPPLY")}</h3>
        <img src={line} alt="line" />
        <h4>{t("CONFIRM_ACTION")}</h4>
        <div className="alert__buttons">
          <Button text={t("IM_SURE")} />
          <Button text={t("CANCEL")} />
        </div>
      </div>
    </div>
  );
};

const Button = ({ text, click }) => {
  return (
    <div className="alert__button" onClick={click}>
      <h6>{text}</h6>
    </div>
  );
};

export default Alert;
